import useHelpStore from './store'
import HelpMessages from './localization'

export default {
  store: useHelpStore,
  localization: HelpMessages,
}
